module.exports = __webpack_public_path__ + "img/optionimage.382409a0.svg";